import { createAsyncThunk } from "@reduxjs/toolkit";

//Include Both Helper File with needed methods
import statisticApi from "api/statisticApi";
import { formatQueryParams } from "helpers/format";

export const getDailyUserStatistics = createAsyncThunk(
  "Daily User Statistics",
  async (params: any = {}) => {
    try {
      const response = await statisticApi.dailyUserStatistics(
        formatQueryParams(params)
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getSummaryStatistics = createAsyncThunk(
  "Summary Statistics",
  async (params: any = {}) => {
    try {
      const response = await statisticApi.summaryStatistics(
        formatQueryParams(params)
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getHotStatistics = createAsyncThunk(
  "Hot Statistics",
  async (params: any = {}) => {
    try {
      const response = await statisticApi.hotStatistics(
        formatQueryParams(params)
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getWallpaperStatistics = createAsyncThunk(
  "Wallpaper Statistics",
  async (params: any = {}) => {
    try {
      const response = await statisticApi.wallpaperStatistics(
        formatQueryParams(params)
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getPhotocardNewsStatistics = createAsyncThunk(
  "Photocard News Statistics",
  async (params: any = {}) => {
    try {
      const response = await statisticApi.photocardNewsStatistics(
        formatQueryParams(params)
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getSnapStatistics = createAsyncThunk(
  "Snap statistics",
  async (params: any = {}) => {
    try {
      const response = await statisticApi.snapStatistics(
        formatQueryParams(params)
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getPushStatistics = createAsyncThunk(
  "Push statistics",
  async (params: any = {}) => {
    try {
      const response = await statisticApi.pushStatistics(
        formatQueryParams(params)
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getBarStatistics = createAsyncThunk(
  "Bar Statistics",
  async (params: any = {}) => {
    try {
      const response = await statisticApi.barStatistics(
        formatQueryParams(params)
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);


export const getAcquisitionStatistics = createAsyncThunk(
  "Acquisition Statistics",
  async (params: any = {}) => {
    try {
      const response = await statisticApi.acquisitionStatistics(
        formatQueryParams(params)
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getRegionalCityStatistics = createAsyncThunk(
  "Regional City Statistics",
  async (params: any = {}) => {
    try {
      const response = await statisticApi.regionalStatistics(
        formatQueryParams(params)
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getRegionalTownStatistics = createAsyncThunk(
  "Regional Town Statistics",
  async (params: any = {}) => {
    try {
      const response = await statisticApi.regionalStatistics(
        formatQueryParams(params)
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getUVLogBarStatistics = createAsyncThunk(
  "UV Log Bar Statistics",
  async (params: any = {}) => {
    try {
      const response = await statisticApi.UVLogBarStatistics(
        formatQueryParams(params)
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);